import {RoleDescriptor} from "../../RoleDescriptor";
import {Route} from "../../../routes/Route";
import {Role} from "../../Role";
import {defineMessage} from "react-intl";

const ChartererManagerMessage = defineMessage({
  id: "chartererManager.name",
  defaultMessage: "Operator, manager",
})

export const chartererManager: RoleDescriptor<Role.chartererManager> = {
  role: Role.chartererManager,
  name: ChartererManagerMessage,
  backendIdentifier: 'charterer_client',
  homeRoute: Route.settings,
  navigation: {
    profile: [
      Route.requests,
    ],
    sidebar: [
      Route.newTripRequest,
      Route.searchEmptyLegs,
      Route.requests,
      Route.settings,
      Route.messageTemplates,
      Route.subscription,
    ]
  },
}